const appleTablets = [
  {
    "title": "iPad Pro 13\" (M4, 2024)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-pro-13-m4-2024",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPad_Pro_13_M4_2024.png?v=1761210779"
  },
  {
    "title": "iPad Pro 11\" (M4, 2024)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-pro-11-m4-2024",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPad_Pro_11_M4_2024.png?v=1761210779"
  },
  {
    "title": "Apple iPad 2/3/4",
    "landingPage": "https://cforcover.com/collections/apple-ipad-2-3-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_2_3_4.webp?v=1761210778"
  },
  {
    "title": "Apple iPad Pro (2020) 11\"",
    "landingPage": "https://cforcover.com/collections/apple-ipad-pro-2020-11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_Pro_2020_11.jpg?v=1761210778"
  },
  {
    "title": "Apple iPad (6th Generation)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-6th-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_6th_Generation.webp?v=1761210776"
  },
  {
    "title": "Apple iPad (5th Generation)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-5th-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_5th_Generation.webp?v=1761210778"
  },
  {
    "title": "Apple iPad mini 4",
    "landingPage": "https://cforcover.com/collections/apple-ipad-mini-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-ipad-mini-4-0.jpg?v=1761210778"
  },
  {
    "title": "Apple iPad Mini (5th Generation)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-mini-5th-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_Mini_5th_Generation.jpg?v=1761210778"
  },
  {
    "title": "Apple iPad Mini (6th Generation)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-mini-6th-generation",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_Mini_6th_Gen.jpg?v=1730954735"
  },
  {
    "title": "Apple iPad Pro 12.9\"",
    "landingPage": "https://cforcover.com/collections/apple-ipad-pro-12-9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_Pro_12.9.jpg?v=1761210778"
  },
  {
    "title": "Apple iPad (9th Generation) 10.2\"",
    "landingPage": "https://cforcover.com/collections/apple-ipad-9th-generation-10-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_9th_Generation_10.2.jpg?v=1761210778"
  },
  {
    "title": "Apple iPad (10th Generation) 10.9\"",
    "landingPage": "https://cforcover.com/collections/apple-ipad-10th-generation-10-9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_10th_Generation_10.9.jpg?v=1761210778"
  },
  {
    "title": "Apple iPad mini 2",
    "landingPage": "https://cforcover.com/collections/apple-ipad-mini-2-7-9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_mini_2.jpg?v=1730954304"
  },
  {
    "title": "Apple iPad mini 3",
    "landingPage": "https://cforcover.com/collections/apple-ipad-mini-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Apple_iPad_mini_3.jpg?v=1730954605"
  },
  {
    "title": "iPad Air (M2, 2024)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-air-m2-2024",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPad_Air_M2_2024.jpg?v=1761210778"
  },
  {
    "title": "iPad Air (4th Gen, 2020)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-air-4th-gen-2020",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPad_Air_4th_Gen_2020.jpg?v=1761210778"
  },
  {
    "title": "iPad Air (3rd Gen, 2019)",
    "landingPage": "https://cforcover.com/collections/apple-ipad-air-3rd-gen-2019",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/iPad_Air_3rd_Gen_2019.jpg?v=1761210778"
  }
]

const samsungTablets = [
  {
    "title": "Samsung Galaxy Tab S11 Ultra",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s11-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S11_Ultra.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S11",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S11.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S10 FE Plus",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s10-fe-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S10_FE_Plus.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S10 FE",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s10-fe",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S10_FE.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S10 Ultra",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s10-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S10_Ultra.jpg?v=1761221384"
  },
  {
    "title": "Samsung Galaxy Tab S10 Plus",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s10-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S10_Plus.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S10 Lite",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s10-lite",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S10_Lite.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S9 Ultra",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s9-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S9_Ultra.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S9 Plus",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s9-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S9_Plus.jpg?v=1761221384"
  },
  {
    "title": "Samsung Galaxy Tab S9 FE Plus",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s9-fe-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S9_FE_Plus.jpg?v=1761221384"
  },
  {
    "title": "Samsung Galaxy Tab S9 FE",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s9-fe-10-9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S9_FE.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S9",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S9.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S8 Ultra",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s8-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S8_Ultra.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S8 Plus",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s8-plus-12-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S8_Plus.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S8",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s8-11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S8.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S7 Plus",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s7-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S7_Plus.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S7 FE",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s7-fe",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S7_FE.webp?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S7",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S7.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S6 Lite",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s6-lite-sm-p610",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S6_Lite.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S6",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s6-sm-t860",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S6.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S5e",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s5e-sm-t725",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S5e.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S4",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-s4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S4.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S3",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s3-sm-t825",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S3.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab S2",
    "landingPage": "https://cforcover.com/collections/samsung-tab-s2-sm-t815",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_S2.webp?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab E",
    "landingPage": "https://cforcover.com/collections/samsung-tab-e-sm-t560",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_E.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab Active5",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-active5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_Active5.jpg?v=1761221384"
  },
  {
    "title": "Samsung Galaxy Tab A9 Plus",
    "landingPage": "https://cforcover.com/collections/samsung-tab-a9-plus-11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A9_Plus.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab A9",
    "landingPage": "https://cforcover.com/collections/samsung-tab-a9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A9.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab A8",
    "landingPage": "https://cforcover.com/collections/samsung-tab-a8-sm-x200-10-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A8.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab A7 Lite",
    "landingPage": "https://cforcover.com/collections/samsung-tab-a7-lite-t225",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A7_Lite.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab A7",
    "landingPage": "https://cforcover.com/collections/samsung-tab-a7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A7.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab A4",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-tab-a4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A4.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab A 10.1",
    "landingPage": "https://cforcover.com/collections/samsung-tab-a-sm-t515-10-1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_A_10.1.jpg?v=1761221385"
  },
  {
    "title": "Samsung Galaxy Tab 3",
    "landingPage": "https://cforcover.com/collections/samsung-tab-3-t116",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Samsung_Galaxy_Tab_3.jpg?v=1761221385"
  }
]

const lenovoTablets = [
  {
    "title": "Lenovo Tab P12",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-p12",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_P12.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab M11",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-m11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_M11.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab M10 5G",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-m10-x505x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_M10_5G.jpg?v=1761222091"
  },
  {
    "title": "Lenovo Tab P11",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-p11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_P11.jpg?v=1761222091"
  },
  {
    "title": "Lenovo Tab P11 Plus",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-p11-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_P11_Plus.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab P11 Pro",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-p11-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_P11_Pro.jpg?v=1761222091"
  },
  {
    "title": "Lenovo Tab M10 Plus",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-m10-plus-x328",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_M10_Plus.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab M8",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-m8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_M8.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab K10",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-k10-fhd",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_K10_FHD.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab M9",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-m9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_M9.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab E7",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-e7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_E7.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab M7",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-m7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_M7.jpg?v=1761222091"
  },
  {
    "title": "Lenovo Tab 4 8",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-4-8-tb-8504x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab4_8.jpg?v=1761222091"
  },
  {
    "title": "Lenovo Tab 4 10",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-4-10",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_4_10.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab 4 8 Plus",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-4-8-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_4_8_Plus.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Tab 4 10 Plus",
    "landingPage": "https://cforcover.com/collections/lenovo-tab-4-10-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Tab_4_10_Plus.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Idea Tab 5G",
    "landingPage": "https://cforcover.com/collections/lenovo-idea-tab-5g",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Idea_Tab_5G.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Idea Tab Pro",
    "landingPage": "https://cforcover.com/collections/lenovo-idea-tab-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Idea_Tab_Pro.jpg?v=1761222090"
  },
  {
    "title": "Lenovo Yoga Tab Plus",
    "landingPage": "https://cforcover.com/collections/lenovo-yoga-tab-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Lenovo_Yoga_Tab_Plus.jpg?v=1761222090"
  }
]

const xiaomiTablets = [
  {
    "title": "Redmi Pad Pro (2025)",
    "landingPage": "https://cforcover.com/collections/redmi-pad-pro-2025",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_Pad_Pro_2025.jpg?v=1761222449"
  },
  {
    "title": "Xiaomi Pad 7 (2025)",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-7-2025",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Pad_7_2025.jpg?v=1761222449"
  },
  {
    "title": "Redmi Pad SE (2024)",
    "landingPage": "https://cforcover.com/collections/redmi-pad-se-2024",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Redmi_Pad_SE_2024.jpg?v=1761222449"
  },
  {
    "title": "Xiaomi Pad 6",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-6-11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Pad_6.jpg?v=1761222449"
  },
  {
    "title": "Xiaomi Pad 6 Pro",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-6-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Pad_6_Pro.jpg?v=1761222448"
  },
  {
    "title": "Xiaomi Pad 5 (2021)",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-5-2021",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Xiaomi_Pad_5_2021.jpg?v=1761222449"
  },
  {
    "title": "Mi Pad 4",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Mi_Pad_4.jpg?v=1761222449"
  },
  {
    "title": "Mi Pad 4 Plus",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-4-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Mi_Pad_4_Plus.jpg?v=1761222449"
  },
  {
    "title": "Mi Pad 3 (2017)",
    "landingPage": "https://cforcover.com/collections/xiaomi-pad-3-2017",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Mi_Pad_3_2017.jpg?v=1761222449"
  }
]

const oneplusTablets = [
  {
    "title": "OnePlus Pad 2 (2025)",
    "landingPage": "https://cforcover.com/collections/oneplus-pad-2-2025",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Pad_2_2025.jpg?v=1761222581"
  },
  {
    "title": "OnePlus Pad Go (2023)",
    "landingPage": "https://cforcover.com/collections/oneplus-pad-go-2023",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Pad_Go_2023.jpg?v=1761222581"
  },
  {
    "title": "OnePlus Pad (2023)",
    "landingPage": "https://cforcover.com/collections/oneplus-pad-11-61",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Pad_2023.jpg?v=1761222581"
  },
  {
    "title": "OnePlus Pad 3",
    "landingPage": "https://cforcover.com/collections/oneplus-pad-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Pad_3.jpg?v=1761222581"
  },
  {
    "title": "OnePlus Pad Lite",
    "landingPage": "https://cforcover.com/collections/oneplus-pad-lite",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/oneplus-pad-lite.jpg?v=1761222580"
  },
  {
    "title": "OnePlus Pad 2 Pro",
    "landingPage": "https://cforcover.com/collections/oneplus-pad-2-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OnePlus_Pad_2_Pro.jpg?v=1761222581"
  }
]

const realmeTablets = [
  {
    "title": "Realme Pad 2",
    "landingPage": "https://cforcover.com/collections/realme-pad-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_pad_2.jpg?v=1761222681"
  },
  {
    "title": "Realme Pad X",
    "landingPage": "https://cforcover.com/collections/realme-pad-x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Pad_X.jpg?v=1761222681"
  },
  {
    "title": "Realme Pad Mini",
    "landingPage": "https://cforcover.com/collections/realme-pad-mini",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Pad_Mini.jpg?v=1761222680"
  },
  {
    "title": "Realme Pad (10.4 inch)",
    "landingPage": "https://cforcover.com/collections/realme-pad-10-4-inch",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Realme_Pad_10.4.jpg?v=1761222680"
  }
]

const huaweiTablets =  [
  {
    "title": "Huawei Media Pad T5 10.1\"",
    "landingPage": "https://cforcover.com/collections/huawei-mediapad-t5-10-1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Huawei_Media_Pad_T5.jpg?v=1761222762"
  },
  {
    "title": "Huawei Media Pad M5 Lite",
    "landingPage": "https://cforcover.com/collections/huawei-mediapad-m5-lite",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Huawei_Media_Pad_M5_Lite.jpg?v=1761222763"
  },
  {
    "title": "Huawei Mate Pad T8",
    "landingPage": "https://cforcover.com/collections/huawei-matepad-t8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Huawei_Mate_Pad_T8.jpg?v=1761222763"
  }
]

const honorTablets = [
  {
    "title": "Honor Pad 8",
    "landingPage": "https://cforcover.com/collections/honor-pad-8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Honor_Pad_8.jpg?v=1761222763"
  }
]

const nokiaTablets = [
  {
    "title": "Nokia T20",
    "landingPage": "https://cforcover.com/collections/nokia-t20",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Nokia_T20.jpg?v=1761222762"
  },
  {
    "title": "Nokia T10",
    "landingPage": "https://cforcover.com/collections/nokia-t10",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Nokia_T10.jpg?v=1761222762"
  }
]

const oppoTablets = [
  {
    "title": "OPPO Pad Air",
    "landingPage": "https://cforcover.com/collections/oppo-pad-air",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/OPPO_Pad_Air_08c4574f-8bfe-4a35-863d-6d50102012f7.jpg?v=1761222763"
  }
]

document.addEventListener("DOMContentLoaded", function () {
  const tabletProducts = [
    ...appleTablets,
    ...samsungTablets,
    ...lenovoTablets,
    ...xiaomiTablets,
    ...oneplusTablets,
    ...realmeTablets,
    ...huaweiTablets,
    ...honorTablets,
    ...nokiaTablets,
    ...oppoTablets
   ];

  // ✅ Match HTML IDs & classes
  const globalSearchTablet = document.querySelector("#global-search-input-tablet");
  const displayGloballyTablet = document.querySelector(".display-models-globally-tablet");

  // ✅ Display function
  const displayTablets = (modelObject) => {
    console.log("Displaying tablet:", modelObject);  // Log the tablet model

    const anchor = document.createElement("a");
    const div1 = document.createElement("div");
    const div2 = document.createElement("div");
    const image = document.createElement("img");
    const para = document.createElement("p");

    anchor.href = modelObject.landingPage;
    anchor.target = "_blank";
    anchor.style.textDecoration = "none";

    div1.className = "one-item";

    image.src = modelObject.imagePath;
    image.alt = modelObject.title;

    para.textContent = modelObject.title;

    div2.appendChild(image);
    div1.appendChild(div2);
    div1.appendChild(para);
    anchor.appendChild(div1);

    displayGloballyTablet.appendChild(anchor);
  };

  // ✅ Search function
  function searchTablet() {
    const searchValue = globalSearchTablet.value.trim().toLowerCase();
    // console.log("Search input:", searchValue);  // Log the search query

    const searchResult = tabletProducts.filter((obj) =>
      obj.title.toLowerCase().includes(searchValue)
    );

    displayGloballyTablet.innerHTML = "";  // Clear previous results

    if (searchResult.length > 0) {
      // console.log("Search results:", searchResult);  // Log search results
      searchResult.forEach((obj) => displayTablets(obj));
      displayGloballyTablet.style.display = "block";
    } else {
      displayGloballyTablet.style.display = "none";
    }

    if (globalSearchTablet.value === "") {
      displayGloballyTablet.innerHTML = "";
      displayGloballyTablet.style.display = "none";
    }
  }

  // ✅ Hide on outside click
  document.addEventListener("click", (event) => {
    if (!displayGloballyTablet.contains(event.target) && event.target !== globalSearchTablet) {
      displayGloballyTablet.style.display = "none";
      globalSearchTablet.value = "";
    }
  });

  // ✅ Input listener
  globalSearchTablet.addEventListener("input", searchTablet);

  // ✅ Default state
  displayGloballyTablet.style.display = "none";
});
